import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';
import useMouseOver from '../Hooks/useMouseOver';

const PopOver = ({
  children, content, className, left,
  right, top, timeout,
}) => {
  const [mostraInfo, onMouseOver, onMouseOut] = useMouseOver();

  useEffect(() => {
    let timeoutId;
    if (mostraInfo && timeout > 1000) {
      timeoutId = setTimeout(onMouseOut, timeout);
    }
    return () => timeoutId && clearTimeout(timeoutId);
  }, [mostraInfo, onMouseOut, timeout]);

  const classes = cns(
    'popover',
    {
      'popover--left': left,
      'popover--top': top,
      'popover--right': right,
      'popover--bottom': !right && !top && !left,
    },
    className,
  );
  return (
    <div
      className={classes}
    >
      <div className="popover__activearea" />
      {mostraInfo && content && (
        <div className="popover__content">
          <div className="popover__innerContent">{content}</div>
        </div>
      )}
      <div
        className="popover__children"
        onBlur={onMouseOut}
        onFocus={onMouseOver}
        onMouseEnter={onMouseOver}
        onMouseLeave={onMouseOut}
      >
        {children}
      </div>
    </div>
  );
};

PopOver.propTypes = {
  /** Contenuto da renderizzare all'interno del componente */
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  /** Classi css personalizzate da aggiungere al componente */
  className: PropTypes.string,
  /** Il contenuto da mostrare */
  content: PropTypes.node,
  /** Mostra il popover a sinistra */
  left: PropTypes.bool,
  /** Mostra il popover a destra */
  right: PropTypes.bool,
  /** Mostra il popover sopra */
  top: PropTypes.bool,
  /** Timeout oltre al quale il popup sparisce anche senza un evento di uscita */
  timeout: PropTypes.number,
};

PopOver.defaultProps = {
  children: null,
  className: '',
  content: null,
  left: false,
  right: false,
  top: false,
  timeout: undefined,
};

export default PopOver;
